const prefix = '';

export default {
  login: prefix + '/login',
  logout: prefix + '/logout',
  slo: prefix + '/slo',
  get_user_info: prefix + '/user/info',
  get_user_permissions: prefix + '/user/permissions',
  //options table
  options_tables: prefix + '/options',
  system_codes: prefix + '/system-codes',
  own_vendor_sites: prefix + '/own-vendor-sites',
  options_tables_implements_by_facility: prefix + '/options/implements-by-facility',
  //end options table
  //top notifications
  get_command_statuses: prefix + '/top/command-statuses',
  top_notification_manifest: prefix + '/top/notification-manifest',
  top_notification_manifest_relation_unsetting: prefix + '/top/notification-manifest-relation-unsetting',
  top_notification_hazardous_reservations: prefix + '/top/notification-hazardous-reservations',
  top_notification_inquiries: prefix + '/top/notification-inquiries',
  top_notification_expirations: prefix + '/top/notification-expirations',
  requested_approve_work_order: () => prefix + 'top/requested-approve-work-orders',
  //end top notifications
  //projects
  projects: prefix + '/projects',
  projects_sales: prefix + '/projects/:id/sales',
  projects_sales_wastes: prefix + '/projects/:id/sales/wastes',
  projects_sales_works: prefix + '/projects/:id/sales/services',
  projects_sales_work_detail: (case_id, work_id) => prefix + `/projects/${case_id}/sales/service/${work_id}`,
  projects_sales_contracts: prefix + '/projects/:id/sales/contracts',
  projects_sales_contracts_detail: (case_id, contract_id) => prefix + `projects/${case_id}/sales/contract/${contract_id}`,
  projects_sales_transport_contract_detail: (case_id, transport_contract_id) => prefix + `projects/${case_id}/sales/transport-contract/${transport_contract_id}`,
  projects_sales_transport_contracts: (case_id) => prefix + `projects/${case_id}/sales/transport-contract`,
  projects_sales_treatment_contracts: (case_id) => prefix + `projects/${case_id}/sales/treatment-contract`,
  projects_sales_estimates: prefix + '/projects/:id/sales/estimates',
  projects_sales_work_orders: (case_id) => prefix + `/projects/${case_id}/work-orders`,
  projects_sales_work_order_upload: (case_id) => prefix + `/projects/${case_id}/sales/work-order/upload`,
  projects_sales_work_order_delete_upload: (case_id, file_id) => prefix + `/projects/${case_id}/sales/work-order/${file_id}/delete-upload`,
  projects_sales_estimates_vehicles_list: (case_id) => prefix + `/projects/${case_id}/sales/estimate/vehicle-list`,
  projects_sales_work_orders_detail: (case_id, work_order_id) => prefix + `/projects/${case_id}/work-orders/${work_order_id}`,
  projects_sales_work_order_not_in_use: (case_id, work_order_id) => prefix + `/projects/${case_id}/work-orders/${work_order_id}/not-in-use`,
  get_workorder_for_sp_schedule_detail: (id) => `/workorder-sp-schedule/${id}`,
  
  //End projects
  popup_search_customers: prefix + '/customers/search-popup',
  popup_search_dischargers: prefix + '/dischargers/search-popup',
  popup_search_discharger_sites: prefix + '/discharger-sites/search-popup',
  popup_search_cases: prefix + '/cases/search-popup',
  popup_search_wastes: prefix + '/wastes/search-popup',
  popup_search_services: prefix + '/services/search-popup',
  popup_search_products: prefix + '/products/search-popup',
  popup_search_vendors: prefix + '/vendors/search-popup',
  popup_search_users: prefix + '/users/search-popup',
  popup_search_users_by_department: prefix + '/users/search-popup-by-department',
  estimates: prefix + '/estimates',
  estimates_confirm: prefix + '/estimates/confirm',
  estimates_export: prefix + '/estimates/export',

  // wastes
  wastes_detail: (id) => prefix + `/wastes/${id}`,
  wastes_detail_json: (dailyReportId,id) => prefix + `/wastes-json/${dailyReportId}/${id}`,
  wastes_detail_by_wos_id: (id) => prefix + `/wastes-wos/${id}`,
  work_order_create: (project_id) => prefix + `/projects/${project_id}/work-orders`,
  work_order_update: (project_id, id) => prefix + `/projects/${project_id}/work-orders/${id}/update`,
  work_order_delete_draft: (project_id, id) => `/projects/${project_id}/work-orders/delete-draft/${id}`,
  work_order_create_wastes_or_services: (project_id) => prefix + `/projects/${project_id}/work-orders/wastes-or-services`,
  work_order_update_status_workflow: (project_id, id) => prefix + `/projects/${project_id}/work-orders/${id}/update_status_of_workflow`,

  //setting_calendar
  setting_calendar_getAll: () => prefix + `/setting-calendar`,

  // work_reservations
  popup_search_waste_categories_by_case_id: (case_id) => prefix + `/projects/${case_id}/work-reservations/waste-categories/search-popup`,
  popup_search_vendor_sites_by_case_id: (case_id) => prefix + `/projects/${case_id}/work-reservations/vendor-sites/search-popup`,
  select_waste_or_service: (case_id) => prefix + `/projects/${case_id}/work-reservations/wastes-or-services`,
  work_reservation_validation: (project_id, work_order_id) => prefix + `/projects/${project_id}/work-orders/${work_order_id}/work-reservations/validation`,
  work_reservation_create: (project_id, work_order_id) => prefix + `/projects/${project_id}/work-orders/${work_order_id}/work-reservations`,
  calendar_setting_upload: prefix + '/setting-calendar/upload',
  calendar_template: prefix + '/setting-calendar/template',
  reservation_dates_validation_type: prefix + '/reservation-dates/validation-type',

  // schedules
  list_reservation: () => prefix + `/work-reservations/reservations`,
  detail_work_reservation_with_work_order: (id) => prefix + `/work-reservations/${id}`,
  list_schedule_by_work_reservation_edit: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}`,
  update_schedules_by_work_reservation: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}`,
  update_regular_schedules_by_work_reservation: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/regular`,
  // update_regular_schedules_by_work_reservation_by_sale: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/regular/by-sale`,
  cancel_schedule_by_car_manager: (id) => prefix + `/schedules/${id}/cancel`,
  delete_schedule_by_car_manager: (id) => prefix + `/schedules/${id}/delete`,
  delete_regular_schedule_by_car_manager: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/regular/delete`,
  delete_all_schedule_by_car_manager: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/delete-all`,
  save_histories_schedules_by_sale: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/save-histories-by-sale`,
  save_histories_regular_schedules_by_sale: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/regular/save-histories-by-sale`,
  checkCarAvailableUser: prefix + '/schedules/check/car-available-user',

  //schedule
  list_schedule_by_type: () => prefix + `/schedules`,
  list_schedule_by_car: () => prefix + `/schedule/car`,
  list_schedule_for_staff: (work_reservation_id) => prefix + `/schedules/work-reservations/${work_reservation_id}/list-schedule-staff`,
  list_department: () => prefix + '/options/department',
  histories_by_schedule: (schedule_id) => prefix + `/schedule/${schedule_id}/histories`,
  transports_treatments: (waste_id) => prefix + `/schedules/transports-treatments/wastes/${waste_id}`,
  regularly_reservation_detail: (case_id, work_reservation_id, id) => prefix + `/projects/${case_id}/work-reservations/${work_reservation_id}/schedules/${id}`,
  car_predetermined_schedules_create: prefix + "/car-predetermined-schedule/create",
  car_predetermined_schedules_update: (id) => prefix + `/car-predetermined-schedule/update/${id}`,
  car_predetermined_schedules_detail: (id) => prefix + `/car-predetermined-schedule/${id}`,
  car_predetermined_schedules_delete: (id) => prefix + `/car-predetermined-schedule/delete/${id}`,
  staff_predetermined_schedules_create: prefix + "/staff-predetermined-schedule/create",
  staff_predetermined_schedules_update: (id) => prefix + `/staff-predetermined-schedule/update/${id}`,
  staff_predetermined_schedules_detail: (id) => prefix + `/staff-predetermined-schedule/${id}`,
  staff_predetermined_schedules_delete: (id) => prefix + `/staff-predetermined-schedule/delete/${id}`,
  factory_predetermined_schedules_create: prefix + "/factory-predetermined-schedule/create",
  factory_predetermined_schedules_update: (id) => prefix + `/factory-predetermined-schedule/update/${id}`,
  factory_predetermined_schedules_detail: (id) => prefix + `/factory-predetermined-schedule/${id}`,
  factory_predetermined_schedules_delete: (id) => prefix + `/factory-predetermined-schedule/delete/${id}`,
  create_by_work_order: (work_order_id) => prefix + `/schedules/create-by-work-order/${work_order_id}`,
  schedule_confirm: () => prefix + `/schedule/confirm`,
  export_delivery_confirmation_letter: prefix + `schedules/export-delivery-confirmation-letter`,
  list_waste_or_service_by_daily_reports: prefix + `schedules/list-waste-or-service-by-daily-reports`,
  list_schedules_after_confirmed: prefix + `schedules/list-schedules-after-confirmed`,
  export_work_certificate: prefix + `schedules/export-work-certificate`,

  //car
  list_schedule_of_car: () => prefix + `/cars/schedules`,

  //waste category
  popup_search_waste_categories_all: prefix + "/waste-categories/search-popup",
  list_waste_categories_after_treatment: prefix + "/waste-categories/list-after-treatment",
  waste_category_for_options: prefix + "/waste-categories/list-options",

  //vendor site
  popup_search_vendor_sites_all: "/vendor-sites/search-popup",
  vendor_sites_select_factory: "/vendor-sites/select-factory",

  // work orders
  detail_work_order: (id) => prefix + `/work-orders/${id}`,
  popup_search_work_order_all: prefix + "/work-orders/search-popup",
  popup_search_work_order_by_case: (case_id) => prefix + `/work-orders/search-popup-by-case/${case_id}`,
  histories_by_work_order: (work_order_id) => prefix + `/work-orders/${work_order_id}/history-workflow`,
  wastes_or_services_by_work_order_id: (work_order_id) => prefix + `/work-orders/${work_order_id}/wastes-or-services-by-work-order`,

  //list of waste by work
  waste_or_service_register: "/projects/waste-or-service/register",

  //info of user logged in
  schedule_today_of_user: prefix + '/user/schedule-today',

  //department
  department_list_options: prefix + '/department/list-options',

  //daily report
  daily_report_factory: "/daily-reports/factory",
  daily_report_approve: prefix + '/daily-reports/search-approve',
  daily_report_transportation: "/daily-reports/transportation",
  daily_report_check_factory: "/daily-reports/factory/check",
  detail_daily_report_with_wastes_or_services: (id, vendorSiteId) =>
    `/daily-reports/${id}/with-wastes-or-services` + (vendorSiteId ? `/${vendorSiteId}` : ''),
  input_daily_report: (id, vendorSiteId) =>
    `/daily-reports/${id}/input` + (vendorSiteId ? `/${vendorSiteId}` : ''),
  approve_daily_report: (id, vendorSiteId) =>
    `/daily-reports/${id}/approve` + (vendorSiteId ? `/${vendorSiteId}` : ''),
  daily_report_update_work_order_json: (id) => `/daily-reports/${id}/update-work-order-information`,
  delete_waste_or_service_by_daily_report: (wasteOrServiceId) => `/daily-reports/wastes-or-services-by-daily-report/${wasteOrServiceId}/delete`,
  delete_by_input_page_waste_or_service_by_daily_report: (wasteOrServiceId) => `/daily-reports/wastes-or-services-by-daily-report/${wasteOrServiceId}/delete-by-input-page`,
  daily_report_detail: (id) => `/daily-reports/${id}/detail`,
  get_info_waste_or_services_by_daily_report: (id) => `/daily-reports/wastes-or-services-by-daily-report/${id}/show`,
  approval_histories_by_daily_report: (id, vendorSiteId) =>
    `/daily-reports/wastes-or-services-by-daily-report/${id}/approval-history` + (vendorSiteId ? `/${vendorSiteId}` : ''),
  create_sales_report_data: "/daily-reports/create-sales-report-data",

  //manifest
  search_manifest: `/manifests`,
  get_jwn_manifest_manual: '/manifests/get-jwndata',
  detail_manifest_attach: (id) => prefix + `manifests/attach/${id}`,
  list_manifests_attach: "/manifests/list-attach",
  attach_manifests: "/manifests/attach",
  delete_manifests_1sts: (id_manifest_1sts) => `/manifests/${id_manifest_1sts}/delete`,
  get_factory_options: '/manifests/factories',

  wastes_or_services_by_work_order: () => `/wastes-or-services-by-work-order`,
  detail_manifest: "/manifests/detail",
  get_jwn_manifest_by_manifest: "/manifests/find/jwn-manifest",
  edit_manifest: (id) => `/manifests/${id}/edit` ,
  create_manifest: "/manifests/create" ,
  store_manifest: "/manifests/create" ,
  get_rerational_dailyreports: (manifest_number)=>`/manifests/relation-daily-reports/${manifest_number}`,

  //discharger_site_notification
  search_discharger_site_notification: "/notifications" ,
  update_or_create_discharger_site_notification: (id = '') => `/notifications/update-or-create${id ? '/' + id : ''}`,
  delete_discharger_site_notification: (id) => `/notifications/${id}/delete`,
  // Inquiries
  search_inquiries: `/inquiries/search`,
  content_inquiries: (id) => `/inquiries/${id}/content`,
  reply_inquiry: (id) => `/inquiries/${id}/reply`,

  //system setting
  update_system_setting: '/system-code/update',
  holidays: '/holidays',
};
